import React, { useEffect } from 'react';

import { defineMessages, FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { ErrorPage, useAnalytics } from '@atlassian/ptc-common';

import NotFoundImage from '../../assets/profile-error/svg-user-not-found_ptc.svg';
import { Link } from '../Router';

import * as Styled from './ProfileError.styled';

const Actions = () => (
	<Link href="search">
		<Button>
			<FormattedMessage {...messages.buttonText} />
		</Button>
	</Link>
);

const NOT_FOUND_IMAGE_WIDTH = 497;

export const UserNotFound = () => {
	const analytics = useAnalytics();
	const expTracker = analytics.expTracker();

	// In a weird case, back and forth by browser back/next button causes `Query` of `react-apollo` does not return `error` correctly although user is not exsited.
	// So it is better to abort all current user experience tracking when user is not found.
	useEffect(() => {
		expTracker.abort({ reason: 'User Not Found' });
	}, [expTracker]);

	return (
		<ErrorPage
			title={<FormattedMessage {...messages.notFoundTitle} />}
			body={
				<>
					<FormattedMessage {...messages.notFoundDescription1} />
					<br />
					<FormattedMessage {...messages.notFoundDescription2} />
				</>
			}
			image={<Styled.NotFoundImage src={NotFoundImage} width={NOT_FOUND_IMAGE_WIDTH} />}
			actions={<Actions />}
		/>
	);
};

const messages = defineMessages({
	notFoundTitle: {
		id: 'ptc-directory.profile-page.not-found.title',
		defaultMessage: 'Looks like we’re off the beaten track',
		description:
			'The title of the error page when a user tries to view a user but the user id does not exist',
	},
	notFoundDescription1: {
		id: 'ptc-directory.profile-page.not-found.description.first',
		defaultMessage: 'We landed here for a user that does not exist.',
		description: 'The first line of the description when a user landed on an invalid page',
	},
	notFoundDescription2: {
		id: 'ptc-directory.profile-page.not-found.description.second',
		defaultMessage: 'Head back to the directory to search for another user.',
		description: 'The second line of the description when a user landed on an invalid page',
	},
	buttonText: {
		id: 'ptc-directory.profile-page.error.home.button',
		defaultMessage: 'Back to directory',
		description: 'The button text to return to the search page',
	},
});
